export const PDF_TEMPLATE_PREVIEW_FETCH_INTERVAL = 1000
